export default __webpack_public_path__ + "organize-internal-test-bash.jpg";